var _path, _path2, _path3, _path4, _use, _use2, _use3, _use4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-mm",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fecb00",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34b233",
    d: "M0 170.7h512V512H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea2839",
    d: "M0 341.3h512V512H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#fff",
    strokeWidth: 188.7,
    d: "M312.6 274H199.4L256 85.3Z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(-144 256 274)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(-72 256 274)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(72 256 274)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(144 256 274)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMm);
export default __webpack_public_path__ + "static/media/mm.88ae9a0f7d78ec27d143bab3c4f6b9cf.svg";
export { ForwardRef as ReactComponent };